import React from "react";

const Register = () => {
  return <div>SignIn</div>;
};

export default Register;
